import { Link } from "wouter";
import {
  IllustrationAscent,
  IllustrationCompass,
  IllustrationFoundation,
  IllustrationPages,
} from "../components/illustrations.jsx";

const PILLARS = [
  {
    kicker: "01 - THE STANDING CHECK",
    title: "Find out where you stand",
    body:
      "Twelve honest questions across six domains. No lecture, no judgement - a plain reading of where you're holding the line and where you're not. Free, and the fastest way to see what Conquest actually is.",
    Illustration: IllustrationCompass,
  },
  {
    kicker: "02 - YOUR CORNER",
    title: "A coach that remembers",
    body:
      "Weekly reviews, first sessions, rough rounds, quarter reviews. Your corner holds your Big 3, your patterns and your floor in mind session to session, so you're not starting from zero every week.",
    Illustration: IllustrationAscent,
  },
  {
    kicker: "03 - THE FLOOR",
    title: "The standard you hold on your worst day",
    body:
      "Not your best week's ambition - the minimum you commit to and Kill, Commit or Contain. When life goes sideways, the floor is what stops the slide. Back to the floor. No shame.",
    Illustration: IllustrationFoundation,
  },
  {
    kicker: "04 - THE PLAYBOOK",
    title: "The method, laid out plainly",
    body:
      "The thinking behind THE ONE, the gateway task, and how the pieces fit together - so you're working a method, not guessing week to week.",
    Illustration: IllustrationPages,
  },
];

export default function Landing() {
  return (
    <div>
      <nav className="topbar">
        <span className="wordmark">CONQUEST</span>
        <div className="navlinks">
          <Link href="/login">Log in</Link>
          <Link href="/signup">Sign up</Link>
        </div>
      </nav>

      <div className="page-wide" style={{ paddingTop: 72 }}>
        <div className="kicker" style={{ marginBottom: 20 }}>
          <span className="the-line" />
          MEN'S DEVELOPMENT, NOT ANOTHER HUSTLE APP
        </div>

        <h1 className="display" style={{ marginBottom: 24, maxWidth: 640 }}>
          Take ground. Hold the line.
        </h1>

        <p style={{ maxWidth: 560, color: "var(--muted)", marginBottom: 40 }}>
          Conquest is a standard you hold yourself to - clarity on where you stand,
          a floor you don't fall below, and a coach who holds the line with you.
          Not fitness gamification, not hustle-brand noise. Clear vision, clear
          objectives, and the structure and brotherhood to execute.
        </p>

        <div className="illustration-hero-wrap">
          <IllustrationAscent className="illustration-hero" />
        </div>

        <div style={{ display: "flex", gap: 14, flexWrap: "wrap", marginBottom: 80 }}>
          <Link href="/take-the-diagnostic" className="btn-primary" style={{ display: "inline-block", textDecoration: "none" }}>
            Take the Standing Check
          </Link>
          <Link href="/signup" className="btn-secondary" style={{ display: "inline-block", textDecoration: "none" }}>
            Sign up
          </Link>
        </div>

        <div className="kicker" style={{ marginBottom: 32 }}>
          <span className="the-line" />
          HOW IT WORKS
        </div>

        <div className="card-grid two-col" style={{ marginBottom: 64 }}>
          {PILLARS.map(({ kicker, title, body, Illustration }) => (
            <div key={kicker} style={{ position: "relative" }}>
              <Illustration className="illustration-card-accent" />
              <div className="kicker" style={{ marginBottom: 14, fontSize: 10.5 }}>
                {kicker}
              </div>
              <h2 style={{ marginBottom: 10 }}>{title}</h2>
              <p style={{ color: "var(--muted)" }}>{body}</p>
            </div>
          ))}
        </div>

        <div className="card" style={{ marginBottom: 64, textAlign: "center" }}>
          <h2 style={{ marginBottom: 12 }}>One honest Monday is where it starts</h2>
          <p style={{ color: "var(--muted)", marginBottom: 24, maxWidth: 480, marginLeft: "auto", marginRight: "auto" }}>
            Take the Standing Check first - it costs nothing and takes a few
            minutes. If it lands, sign up and start holding the line.
          </p>
          <div style={{ display: "flex", gap: 14, justifyContent: "center", flexWrap: "wrap" }}>
            <Link href="/take-the-diagnostic" className="btn-primary" style={{ display: "inline-block", textDecoration: "none" }}>
              Take the Standing Check
            </Link>
            <Link href="/login" className="btn-secondary" style={{ display: "inline-block", textDecoration: "none" }}>
              Log in
            </Link>
          </div>
        </div>

        <div style={{ borderTop: "1px solid var(--hairline)", paddingTop: 24, paddingBottom: 24, color: "var(--muted)", fontSize: 13 }}>
          CONQUEST
        </div>
      </div>
    </div>
  );
}
